import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ControlMessagesComponent } from '../../components/controlmessagecomponent/controlmessagecomponent';

@NgModule({
  declarations: [ControlMessagesComponent],

  exports: [
    ControlMessagesComponent
  ],
  imports: [IonicModule],

})
export class ControlMessagesComponentModule { }




// WEBPACK FOOTER //
// ./src/components/controlmessagecomponent/controlmessagecomponent.module.ts